/* eslint-disable no-unused-vars */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Countdown from 'react-countdown';

import './SalesLargeCountdown.style';

/** @namespace Pwa/Component/Countdown/SalesLargeCountdown/SalesLargeCountdown */
export class SalesLargeCountdown extends PureComponent {
    static propTypes = {
        endDate: PropTypes.string.isRequired,
        onComplete: PropTypes.func
    };

    static defaultProps = {
        onComplete: () => {}
    };

    renderCountdown = ({
        days, hours, minutes, seconds, completed
    }) => {
        const { onComplete } = this.props;
        if (completed) {
            onComplete();
            return null;
        }

        return (
            <div block="LargeCountdown" elem="Block">
                <div>
                    <div className="large-countdown-timer">
                        <div className="time-box">
                            <div className="time">
                                <span>{ String(days).padStart(2, '0')[0] }</span>
                                <span>{ String(days).padStart(2, '0')[1] }</span>
                            </div>
                            <div className="label">
                                { __('Days') }
                            </div>
                        </div>
                        <span className="separator">:</span>
                        <div className="time-box">
                            <div className="time">
                                <span>{ String(hours).padStart(2, '0')[0] }</span>
                                <span>{ String(hours).padStart(2, '0')[1] }</span>
                            </div>
                            <div className="label">
                                { __('Hours') }
                            </div>
                        </div>
                        <span className="separator">:</span>
                        <div className="time-box">
                            <div className="time">
                                <span>{ String(minutes).padStart(2, '0')[0] }</span>
                                <span>{ String(minutes).padStart(2, '0')[1] }</span>
                            </div>
                            <div className="label">
                                { __('Minutes') }
                            </div>
                        </div>
                        <span className="separator">:</span>
                        <div className="time-box">
                            <div className="time">
                                <span>{ String(seconds).padStart(2, '0')[0] }</span>
                                <span>{ String(seconds).padStart(2, '0')[1] }</span>
                            </div>
                            <div className="label">
                                { __('Seconds') }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { endDate } = this.props;

        const endTime = Date.parse(endDate);

        if (!endDate || Number.isNaN(endTime)) {
            console.error('Invalid end date configuration:', endDate);
            return null;
        }

        return <Countdown date={ endTime } renderer={ this.renderCountdown } />;
    }
}

export default SalesLargeCountdown;
